import { f as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-577f616b.js';
import { styled } from '@mui/material/styles';
import MUILinearProgress__default from '@mui/material/LinearProgress';

var _templateObject;
var GgxLinearProgressbar = styled(MUILinearProgress__default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiLinearProgress-barColorPrimary {\n    background-color: #fd0;\n  }\n  & {\n    background-color: #0088bf;\n  }\n"])));
GgxLinearProgressbar.displayName = 'GgxLinearProgressbar';

export { GgxLinearProgressbar as G };
